
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Gastrointestinal_stromal_tumor",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Gastrointestinal_stromal_tumor.vue